import React from "react";
import { useRouter } from "next/router";
import { ArrowLeftIcon } from "@heroicons/react/outline";
import CartIcon from "components/CartIcon";
import { useMenuContext } from "context/MenuContext";
import Link from "next/link";

interface Props {}
const ProductNavBar: React.FC<Props> = () => {
  const router = useRouter();
  const storeSlug = router.query.store_name;
  const { business_name, navbarDesign } = useMenuContext();
  const backgroundColor = navbarDesign.backgroundColor;
  const textColor = navbarDesign.textColor;
  const title = navbarDesign.title || business_name;

  return (
    <div
      className="p-4 flex justify-between"
      style={{ backgroundColor, color: textColor }}
    >
      <ArrowLeftIcon className="h-6 w-6" onClick={() => router.back()} />
      <Link  href={`/${storeSlug}`} className="truncate-2-lines text-center font-medium xs:text-lg text-sm">
        {title?.trim()}
      </Link>
      {/* @ts-ignore */}
      <CartIcon storeSlug={storeSlug} />
    </div>
  );
};

export default ProductNavBar;
